import { Pipe, PipeTransform, inject } from '@angular/core';
import { translation } from '@cue/translations';
import { ConfigService } from '@assist/shared/data';
import { AssistResourceBM } from '@cue/api';
import { TranslocoService } from '@jsverse/transloco';
import { localized } from '@cue/translate';

@Pipe({
  name: 'resourceTitle',
  standalone: true,
})
export class ResourceTitlePipe implements PipeTransform {
  private configService = inject(ConfigService);
  private translocoService = inject(TranslocoService);
  translation = translation;

  transform(value: AssistResourceBM): string {
    return `${localized(value.displayNameForApp, this.translocoService) ?? localized(value.displayName, this.translocoService)}
      (${localized(this.configService.getResourceTypeFromId(value.resourceTypeId).name, this.translocoService)})`;
  }
}
